<template>
  <div id="container-link-contracts">
      <div class="header-module">
		  <div class="header-col-one">
            <div class="search-icon">
                <input type="text" class="search-contract" v-model="search" placeholder="Pesquisar contrato">
                <i class="fas fa-search"/>
            </div>
		  </div>
      </div>

        <div class="total-os">
            <span>Total de {{ totalRegisters }} chamados</span>
        </div>

      <div class="content">
          <table id='contract-table' class="tables mb-6 contract-table">
              <thead class="header-table">
                    <th class="text-center" @click="orderBy('protocol')">
                        <i class="fas fa-hashtag" />
                        Protocolo
						<i :class="iconSort('protocol')"/>
                    </th>

                    <th class="text-center" @click="orderBy('created_at')">
                        <i class="fas fa-calendar-alt" />
                        Abertura
                        <i :class="iconSort('created_at')"/>
                    </th>

                    <th class="text-center" @click="orderBy('sla')">
                        <i class="fas fa-calendar-times" />
                        SLA
                    </th>

                    <th class="text-center" @click="orderBy('customer_name')">
                        <i class="fas fa-user" />
                        Cliente
                        <i :class="iconSort('customer_name')"/>
                    </th>

                    <th class="text-center" @click="orderBy('priority')">
                        <i class="fas fa-exclamation-triangle"/>
                        Prioridade
                        <i :class="iconSort('priority')"/>
                    </th>
                    
                    <th class="text-center" @click="orderBy('type_name')">
                        <i class="fas fa-network-wired" />
                        Tipo de Chamado
                        <i :class="iconSort('type_name')"/>
                    </th>

                    <th class="text-center" @click="orderBy('department_name')">
                        <i class="fas fa-city" />
                        Departamento
                        <i :class="iconSort('department_name')"/>
                    </th>

                    <th class="text-center" @click="orderBy('technician_id')">
                        <i class="fas fa-wrench" />
                        Responsavel
                        <i :class="iconSort('technician_id')"/>
                    </th>

                    <th class="text-center" @click="orderBy('description')">
                        <i class="fas fa-align-left" />
                        Descrição
                        <i :class="iconSort('description')"/>
                    </th>
              </thead>

                <!---------- corpo da tabela ---------->
                <tr v-for="(item, index) in searchElements" :key="index" class="tables mb-6 body-table">
                    <td>{{ item.protocol }}</td>
                    <td>{{ formatDate(item.created_at) }}</td>
                    <td>{{ slaTime(item.created_at, item.sla) }}</td>
                    <td>{{ item.customer_name }}</td>
                    <td>{{ item.priority }}</td>
                    <td>{{ item.type_name }}</td>
                    <td>{{ item.department_name }}</td>
                    <td>{{ item.technician_id }}</td>
                    <td class="tooltip-container cursor-pointer">
                        <span class="tooltip-text">
                            <span>{{ item.description }}</span>
                        </span>
                        {{ formatLongText(item.description, 10) }}
                    </td>
                </tr>
            </table>
      </div>

      <footer class="footer-table">
            <div class="registers"><i class="fas fa-book-open"/> Página {{ currentPage }} de {{ totalPages }}</div>
            <div class="pagination">
                <button class="btn btn-outline-primary previus" @click="prevPage">
                    <i class="fas fa-angle-left"/> Anterior
                </button>
                <button :class="currentPage == page ? 'btn btn-primary' : 'btn btn-outline-primary'" @click="currentPage = page" v-for="(page, index) in showPages" :key="index">{{ page }}</button>
                <button class="btn btn-outline-primary next" @click="nextPage">
                    Proxima <i class="fas fa-angle-right" />
                </button>
            </div>
        </footer>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';

export default {
    data() {
        return {
            showModal: false,
            contracts: [],
            edit: {},
            permission: false,
            search: '',
            currentSort: '',
            currentSortDir: 'asc',
            pageSize: 6,
            currentPage: 1,
            totalPages: 0,
            totalRegisters: 0,
            timeReq: () => {}
        }
    },
    computed: {
        searchElements() {
            const filter = this.contracts.filter(row => {
                const whatSearch = this.search.toLowerCase();
                const protocol = row.protocol;
                const createdAt = row.created_at.toLowerCase();
                const priority = row.priority.toLowerCase();
                const customerName = row.customer_name.toLowerCase();
                const departmentName = row.department_name.toLowerCase();
                const typeName = row.type_name.toLowerCase();
                const sla = row.sla.toLowerCase();
                const technicianId = row.technician_id.toLowerCase();
                const description = row.description.toLowerCase();
                
                return (
                    protocol.includes(whatSearch) ||
                    createdAt.includes(whatSearch) ||
                    priority.includes(whatSearch) ||
                    customerName.includes(whatSearch) ||
                    departmentName.includes(whatSearch) ||
                    typeName.includes(whatSearch) ||
                    sla.includes(whatSearch) ||
                    technicianId.includes(whatSearch) ||
                    description.includes(whatSearch)
                );
            });

            this.totalPages = Math.ceil(filter.length / this.pageSize);
            this.totalRegisters = filter.length;
            return this.paginate(filter);
        },
    },
    methods: {
        iconSort(sort) {
            if(this.currentSort == sort) {
                return this.currentSortDir == 'asc' ? 'fas fa-sort-amount-up' : 'fas fa-sort-amount-down';
            } else {
                return '';
            }
        },
        formatLongText(text, lengthTxt = 30) {
            return text && text.length > lengthTxt ? text.substring(lengthTxt, 0) + '...' : text;
        },
        updateOccurrences() {
            this.getOccurrences();
            this.timeReq = setInterval(() => {
                this.getOccurrences();
            }, 5000);
        },
        getOccurrences() {
            axios.get("/getOccurrenceExpired").then(({ data }) => {
                this.contracts = data.map(item => {
                    item.priority = item.priority == 1 ? "Sim" : "Não";
                    item.technician_id = item.technician_id ? item.technician_id.toString() : "";
                    return item;
                });

                this.totalPages = Math.ceil(data.length / this.pageSize);
                this.totalRegisters = data.length;
            });
        },
        formatDate(date) {
            return moment(date).format("DD/MM/YYYY HH:mm:ss");
        },
        orderBy(sort) {
            if(sort == this.currentSort) {
                this.currentSortDir = this.currentSortDir == 'asc' ? 'desc' : 'asc';
            }
            this.currentSort = sort;
        },
        paginate(data) {
            return data.sort((a, b) => {
                let modifier = 1;
                if(this.currentSortDir == 'desc') modifier = -1;
                if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                return 0;
            }).filter((row, index) => {
                const start = (this.currentPage - 1) * this.pageSize;
                const end = this.currentPage * this.pageSize;
				return (index >= start && index < end);
            });
        },
        nextPage() {
            if((this.currentPage * this.pageSize) < this.contracts.length) this.currentPage++;
        },
        prevPage() {
            if(this.currentPage > 1) this.currentPage--;
        },
        pageScroll() {
            window.scrollBy(0,1);
            scrolldelay = setTimeout(pageScroll,10);
        },
        stopReq() {
            clearInterval(this.timeReq);
        },
        autoPaginate() {
            let proximo = true;
            setInterval(() => {
                if (this.currentPage == this.totalPages) proximo = false;
                if (this.currentPage == 1) proximo = true;
                if (proximo) this.nextPage();
                if (!proximo) this.prevPage();
            }, 8000)
        },
        slaTime: function(created, sla) {
            const createdDate = new Date(created);
            const slaSplit = sla.split(':');
            const inSeconds = (+slaSplit[0]) * 60 * 60 + (+slaSplit[1]) * 60 + ((+slaSplit[2]));
            const dateResult = moment(createdDate).add(inSeconds, 'seconds');
            return this.formatDate(dateResult._d);
        },
    },
    beforeMount() {
        this.updateOccurrences();
    },
    created() {
        this.autoPaginate();
        console.log("This is time: ", this.slaTime("2022-03-23 10:30:00", "01:30:17"));
    }

}
</script>

<style scoped>

.footer-table {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

.total-os {
    background-color: #1C869A;
    font-weight: bold;
    color: white;
    padding: 0px 10px;
    width: 170px;
    border-radius: 4px 4px 0px 0px;
}

.previus {
    border-radius: 5px 0px 0px 5px !important;
}

.next {
    border-radius: 0px 5px 5px 0px !important;
}

#btn-new-contract {
    font-weight: bold;
    border-radius: 5px !important;
    margin-left: 10px;
}

.header-module {
    margin-bottom: 20px;
}

.header-module .header-col-one {
    display: flex;
    justify-content: space-between;
}

.header-module .header-col-two {
	margin-top: 20px;
	margin-left: 10px;
    display: flex;
}
.quantity-viewed {
    margin-right: 10px;
}

.quantity-viewed select {
	border: solid 1px #aaa;
	border-left: none;
	border-radius: 0px 5px 5px 0px !important;
	padding: 3px 5px;
	text-align: center;
}

.quantity-viewed span {
	border: none;
	border-radius: 5px 0px 0px 5px !important;
	padding: 5px 10px;
	background-color: #3a86ff;
	color: white;
	font-weight: 600;
}

.quantity-viewed select:focus {
	box-shadow: 0 0 10px 0 #3a86ff;
    border: solid 1px #3a86ff;
    outline: none;
}

.search-contract {
    position: relative;
    width: 400px;
    border: solid 1px #aaa;
    border-radius: 20px !important;
    padding: 5px 35px 4px 15px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.8);
}

.search-contract:focus {
    box-shadow: 0 0 10px 0 #3a86ff;
    border: solid 2px #3a86ff;
    outline: none;
}

.search-icon i {
    color: #aaa;
    position: relative;
    top: 0px;
    right: 35px;
}

.search-contract:focus + i {
    color: #3a86ff;
}

.content {
    width: 100%;
    overflow-x: auto;
    border-radius: 0px 5px 5px 5px;
}

.contract-table {
    width: 100%;
    border-collapse: separate;
	font-size: 1em;
	font-family: "Sulphur Point", sans-serif;
}

.contract-table td {
    padding: 5px;
    text-align: center;
    vertical-align: middle;
}

.contract-table td button {
    border-radius: 5px !important;
}

.contract-table th {
    width: 150px;
    position: sticky;
    top: 0;
	/* background-color: #3a86ff; */
	color: white;
    vertical-align: middle;
    text-align: center;
	padding: 5px 20px;
	font-weight: bold;
    border-right: solid 0.5px white;
    border-left: solid 0.5px white;
    cursor: pointer;
}

.contract-table tr {
    -webkit-animation: glowingIn 1400ms infinite;
    -moz-animation: glowingIn 1400ms infinite;
    -o-animation: glowingIn 1400ms infinite;
    animation: glowingIn 1400ms infinite;
    color: white;
}

.contract-table tr:nth-child(even) {
    -webkit-animation: glowingIn 1500ms infinite;
    -moz-animation: glowingIn 1500ms infinite;
    -o-animation: glowingIn 1500ms infinite;
    animation: glowingIn 1500ms infinite;
}

.header-table {
    position: static;
}

.header-table th:first-child {
	border-left: none;
}

.header-table th:last-child {
	border-right: none;
}

.contract-table > tr:hover {
	background-color: rgba(0, 0, 0, 0.1);
}

.tooltip-container {
    /* position: relative; */
    padding-left: 40px;
    margin-bottom: 25px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.registers {
    color: #1C869A;
    font-weight: bold;
    margin-left: 5px;
}

.tooltip-text {
    visibility: hidden;
    width: 400px;
    background-color: white;
    color: black;
    font-size: 0.8em;
    text-align: left;
    border-radius: 5px;
    padding: 25px;
    position: absolute;
    z-index: 1;
    top: 72px;
    right: 170px;
    box-shadow: 0 0 2em black;
}

.tooltip-container:hover .tooltip-text{
    visibility: visible;
}

.tooltip-text::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 12px;
    border-color: white transparent transparent white;
    transform: rotate(135deg);
    top: 12px;
    right: -12px;
    border-radius: 6px 0px 0px 0px;
}

#contract-table > tr:nth-child(2) > th:nth-child(5) {
    display: none;
}

@media (max-height: 807px) {
    .content {
        height: 55vh;
    }
}

@-webkit-keyframes glowingIn {
  0% { background-color: #B20000; -webkit-box-shadow: 0 0 3px #B20000; }
  50% { background-color: #FF0000; -webkit-box-shadow: 0 0 40px #FF0000; }
  100% { background-color: #B20000; -webkit-box-shadow: 0 0 3px #B20000; }
}

@-moz-keyframes glowingIn {
  0% { background-color: #B20000; -moz-box-shadow: 0 0 3px #B20000; }
  50% { background-color: #FF0000; -moz-box-shadow: 0 0 40px #FF0000; }
  100% { background-color: #B20000; -moz-box-shadow: 0 0 3px #B20000; }
}

@-o-keyframes glowingIn {
  0% { background-color: #B20000; box-shadow: 0 0 3px #B20000; }
  50% { background-color: #FF0000; box-shadow: 0 0 40px #FF0000; }
  100% { background-color: #B20000; box-shadow: 0 0 3px #B20000; }
}

@keyframes glowingIn {
  0% { background-color: #B20000; box-shadow: 0 0 3px #B20000; }
  50% { background-color: #FF0000; box-shadow: 0 0 40px #FF0000; }
  100% { background-color: #B20000; box-shadow: 0 0 3px #B20000; }
}

</style>
